import type User from 'modules/core/store/models/User'

import ValidateIban from 'modules/payroll_bundle/lib/ValidateIban'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

import type { PaymentItemLikeMinimal } from 'modules/payroll_bundle/pages/ResultsAndPaymentsPage/PaymentsPage/GeneratePaymentsPage/Table/useDraftPaymentItemsDataCollectionSource'

function getPaymentAttrs(paymentItem: PaymentItemLikeMinimal | PaymentItem): {
  amount?: number
  employee_id?: string | number
  bank_account?: string
} {
  return paymentItem.attributes ?? {}
}

export const disablePaymentItem = (
  paymentItem: PaymentItemLikeMinimal | PaymentItem,
  user: User | null | undefined
): boolean => {
  const attrs = getPaymentAttrs(paymentItem)
  const bankAccount = attrs.bank_account

  return !user || !attrs.amount || !attrs.employee_id || !bankAccount || !ValidateIban(bankAccount)
}
